'use client';

import clientLogger from '@/lib/logger/client';
import { getDatadogRum } from '@/lib/datadog';

export function reportBoundaryError(error: Error & { digest?: string }, boundary: string): void {
	const context = {
		boundary,
		digest: error.digest,
		page: window.location.pathname,
		source: 'error-boundary' as const,
	};

	clientLogger.error({ error, ...context }, `Error boundary caught: ${boundary}`);

	// RUM may be null if the error fires before initializeDatadogRum() resolves — the log channel still captures it
	const rum = getDatadogRum();
	if (rum) {
		rum.addError(error, context);
	}
}
